
import $ from 'jquery';
import template from 'common-views/select-stages-and-roles.ejs';
import constants from 'Constants';
import SettingsModalBase from 'common-views/SettingsModalBase';

class StageAndRoleSettingsModal extends SettingsModalBase {

    initialize( opts ){
        super.initialize( opts );

        this.template = template;
        this.defaultValue = opts.defaultValue || "no";
        this.title = opts.title || 'Edit Mandatory';

        this.initMap();
        this.initModel();

        $('body').append(this.$el);
    }

    setNewValue( newValue ) {
        this.model.set('viewingState', newValue, {silent:true});
    }

    triggerUpdate( ) {
        this.model.trigger(constants.EV_ROLE_AND_STAGE_SETTINGS_UPDATED);
        this.model.trigger(constants.EV_ISMANDATORY_ROLE_OR_STAGE_UPDATED);
    }

}

export default StageAndRoleSettingsModal;
